import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Form, Spinner, Alert } from 'react-bootstrap'
import MediaQuery from 'react-responsive'
import { withTranslation } from 'react-i18next'
import { action, observable, makeObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import styled, { withTheme } from 'styled-components'
import { debounce } from 'throttle-debounce'

import { formatedPriceObject } from '../../utils/formatedPrice'
import { getErrorMessageFromApiResponse } from '../../utils/api/apiUtils'
import PlusMinusAmount from '../Forms/PlusMinusAmount'
import { OverlayLoadingLayer } from '../Loading/OverlayLoadingLayer'
import { colors } from '../../styles/colors'
import {
  CategoryIconDefault,
  CategoryIcons,
} from '../Icons/CategoryIcons/CategoryIcons'
import trash from '../../assets/icons/trash.svg'
import { PenIcon } from '../Icons/PenIcon'
import { isEmptyGuid } from '../../utils/emptyGuid'

const StyledProductItemWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 85px 1fr auto;
  border-bottom: 1px solid ${colors.gray1};

  @media screen and (min-width: 992px) {
    grid-template-columns: 85px 1fr 140px 115px 100px;
    align-items: center;
  }
  @media (max-width: 567px) {
    display: flex !important;
    flex-direction: column !important;
    grid-template-columns: none !important;
  }
`

const StyledProdcutHeader = styled.div`
  opacity: 0.5;
`

const StyledImgCol = styled.div`
  align-self: center;
  grid-row: span 2;

  @media screen and (min-width: 992px) {
    grid-row: auto;
  }
  @media (max-width: 567px) {
    margin-bottom: 10px;
  }
`

const StyledProductImgWrap = styled.div`
  width: 85px;
  height: 85px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`

const StyledProductImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`

const StyledProductDescriptionCol = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  grid-column: span 2;
  @media screen and (min-width: 430px) {
    grid-column: auto;
  }
  @media (max-width: 567px) {
    font-size: 0.9rem;
    padding: 0;
  }
`

const StyledProductSubDescription = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
  @media (max-width: 567px) {
    font-size: 0.9rem;
  }
`
const StyledProductLocalStoreHouse = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
  @media (max-width: 567px) {
    font-size: 0.9rem;
  }
`

const StyledPriceCol = styled.div`
  align-self: end;
  grid-row: 2;
  grid-column: 3;
  text-align: right;
  white-space: nowrap;

  @media screen and (min-width: 430px) {
    grid-row: 1;
  }
  @media screen and (min-width: 992px) {
    align-self: auto;
    grid-row: auto;
    grid-column: auto;
    padding: 20px;
  }
  @media (max-width: 567px) {
    margin: 10px 0px;
  }
`

const StyledOptionsCol = styled.div`
  grid-column: 3;
  text-align: right;
  white-space: nowrap;

  @media screen and (min-width: 992px) {
    grid-column: auto;
    padding: 20px 0 20px 20px;
  }
`

const StyledRemoveLink = styled(Link)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  color: #ff0000;
  background-color: #ffe5e5;
  border: 1px solid #ffb3b3;
  border-radius: 6px;
  padding: 8px 12px;
  text-decoration: none;
  font-size: 0.9em;

  &:hover {
    background-color: #ffd6d6;
    color: #bf0000;
  }

  &:after {
    content: '';
    width: 1em;
    height: 1.1em;
    display: inline-block;
    margin-left: 0.25em;
    top: -2px;
    position: relative;
    vertical-align: middle;
    background: url(${trash}) center center no-repeat;
    background-size: contain;
  }

  @media (max-width: 567px) {
    flex: 1 !important;
    width: 100% !important;
    // padding: 10px;
    white-space: nowrap;
  }
`

const StyledAmountLabel = styled(Form.Label)`
  @media screen and (max-width: 991px) {
    padding: 12px 16px;
    display: inline-block;
  }
  @media (max-width: 567px) {
    font-size: 0.9rem;
    padding: 12px 0px;
    margin-bottom: 0 !important;
  }
`
const StyledAmountGroup = styled(Form.Group)`
  padding: 0 20px;

  @media (max-width: 567px) {
    display: flex;
    font-size: 0.9rem;
    justify-content: space-between;
    padding: 0;
    input {
      font-size: 1rem !important;
      height: 32px !important;
      padding: 4px 6px !important;
    }

    button {
      font-size: 1rem !important;
      padding: 4px 10px !important;
      height: 32px !important;
    }
  }
`

class ProductItem extends Component {
  changeQuantityError = null
  quantity = null
  isLoading = false
  constructor(props) {
    super(props)

    makeObservable(this, {
      changeQuantityError: observable,
      quantity: observable,
      isLoading: observable,
      setShowUpdateLocalInstancesModal: action,
    })

    this.quantity = props.position.quantity
  }
  setShowUpdateLocalInstancesModal = (bool) => {
    const { productsStore, article, position } = this.props
    productsStore.setShowUpdateLocalInstancesModal(bool)
    if (bool) {
      productsStore.initUpdateLocalInstances(article.id, position.id)
    }
  }
  onClickRemove = async (e) => {
    e.preventDefault()
    const { article, position, productsStore } = this.props
    await productsStore.removeArticleFromBasket(article.id, position.id)
  }

  onClickPlusIcon = async (e) => {
    const { article } = this.props
    e.preventDefault()
    this.quantity += article.article.packageSize
      ? article.article.packageSize
      : 1
    await this.changeQuantityInBasketDebounced(this.quantity)
  }

  onClickMinusIcon = (e) => {
    const { article } = this.props
    e.preventDefault()
    this.quantity -= article.article.packageSize
      ? article.article.packageSize
      : 1
    this.changeQuantityInBasketDebounced(this.quantity)
  }
  onChangeQauantity = async (e) => {
    const { value } = e.target
    if (parseInt(value)) {
      this.quantity = parseInt(value)
      await this.changeQuantityInBasketDebounced(this.quantity)
    }
  }
  changeQuantityInBasketDebounced = debounce(750, (quantity) => {
    const { article, position, productsStore } = this.props
    this.isLoading = true
    this.changeQuantityError = null
    productsStore
      .changePositionQuantity(article.id, position, quantity)
      .catch((e) => {
        this.quantity = position.quantity
        this.changeQuantityError = getErrorMessageFromApiResponse(e)
      })
      .finally(() => {
        this.isLoading = false
      })
  })

  getProductHeadline = () => {
    const { article } = this.props
    let chunks = []
    if (
      article.contingentAvailability &&
      article.contingentAvailability.displayName
    ) {
      chunks.push(article.contingentAvailability.displayName)
    }
    if (
      article.categoryAvailability &&
      article.categoryAvailability.displayName
    ) {
      chunks.push(article.categoryAvailability.displayName)
    }
    return chunks.join(' / ')
  }

  getSubDescription = (position) => {
    const { articleVariant, configurations } = position
    let subDescriptionParts = []

    if (articleVariant) {
      /*if (articleVariant.groupDisplayName) {
        subDescriptionParts.push(articleVariant.groupDisplayName)
      }*/

      if (
        articleVariant.separatedDisplayName &&
        articleVariant.separatedDisplayName.length
      ) {
        subDescriptionParts.push(articleVariant.separatedDisplayName.join(' '))
      } else {
        if (articleVariant.displayName) {
          subDescriptionParts.push(articleVariant.displayName)
        }
      }
    }

    if (configurations.length) {
      configurations.forEach((config) => {
        let configText = `${config.name}: ${config.article.displayName}`
        if (config.comment) {
          configText = configText + '; ' + config.comment
        }
        subDescriptionParts.push(configText)
      })
    }

    if (position.comment) {
      subDescriptionParts.push(position.comment)
    }

    return subDescriptionParts.length ? subDescriptionParts.join(' | ') : ''
  }
  getLocalStoreHouse = (position, t) => {
    const { localStorehouse } = position
    if (localStorehouse) {
      return t('translation:DirectOutput') + ': ' + localStorehouse.displayName
    }
    return ''
  }
  getLocalInstances = (article, position, t) => {
    const { instances, localStorehouse } = position
    if (
      !isEmptyGuid(localStorehouse?.id) &&
      (article.article.useSerialKeys ||
        article.article.useBatchKeys ||
        article.article.useRFIDs)
    ) {
      let instancesParts = []
      if (instances && instances.length) {
        instances.forEach((instance) => {
          let key = ''
          if (instance.serialKey) {
            key = instance.serialKey
          } else if (instance.batchKey) {
            key = instance.batchKey
          } else if (instance.rfid) {
            key = instance.rfid
          }
          instancesParts.push(key)
        })
      }
      return (
        <>
          {t('translation:Instances') +
            ': ' +
            (instancesParts.filter(Boolean).length ? instancesParts.filter(Boolean).join(' | ') : '')}
          <PenIcon
            className='action-button'
            style={{ cursor: 'pointer', marginLeft: '5px' }}
            title={t('edit')}
            onClick={() => {
              this.setShowUpdateLocalInstancesModal(true)
            }}
          />
        </>
      )
    }
    return ''
  }
  render() {
    const {
      t,
      productsStore,
      deletable,
      theme,
      article,
      position,
      productDetailsStore,
    } = this.props
    const CategoryIcon =
      this.props.iconType && CategoryIcons[this.props.iconType]
        ? CategoryIcons[this.props.iconType]
        : CategoryIconDefault
    const isRemoving = productsStore.removingPositionFromBasket[position.id]
    const productHeadline = this.getProductHeadline()
    const subDescription = this.getSubDescription(position)
    const localStoreHouse = this.getLocalStoreHouse(position, t)
    const localInstances = this.getLocalInstances(article, position, t)

    let sumPriceObject, sumPrice, sumShortPrice

    if (position.pricePerItem !== null) {
      sumPriceObject = {
        price:
          position.pricePerItem.price === null
            ? null
            : position.pricePerItem.price * position.quantity,
        currency: position.pricePerItem.currency,
        points:
          position.pricePerItem.points === null
            ? null
            : position.pricePerItem.points * position.quantity,
      }
      sumPrice = formatedPriceObject(sumPriceObject)
      sumShortPrice = formatedPriceObject(sumPriceObject, true)
    }

    return (
      <React.Fragment>
        <StyledProductItemWrapper
          className={this.isLoading ? 'is-loading' : ''}
        >
          <StyledImgCol>
            <Link to={productDetailsStore.getProductToUrl(article)}>
              <StyledProductImgWrap>
                {article.article.image && article.article.image.url ? (
                  <StyledProductImg src={article.article.image.url} alt='' />
                ) : (
                  <CategoryIcon color={theme.primaryColor} />
                )}
              </StyledProductImgWrap>
            </Link>
          </StyledImgCol>
          <StyledProductDescriptionCol>
            <StyledProdcutHeader className='text-primary'>
              <i>
                <small>{productHeadline}</small>
              </i>
            </StyledProdcutHeader>
            <span>{article.article.displayName}</span>
            <StyledProductSubDescription>
              {subDescription}
            </StyledProductSubDescription>
            <StyledProductLocalStoreHouse>
              {localStoreHouse}
            </StyledProductLocalStoreHouse>
            <small>{localInstances}</small>
          </StyledProductDescriptionCol>
          <StyledAmountGroup>
            <StyledAmountLabel>{t('amount')}</StyledAmountLabel>
            <PlusMinusAmount
              placeholder='1'
              value={this.quantity}
              onChange={this.onChangeQauantity}
              onChangePlus={this.onClickPlusIcon}
              onChangeMinus={this.onClickMinusIcon}
              disableMinus={
                this.quantity === 1 ||
                this.quantity <= article.article.minimumQuantity
              }
              disablePlus={
                article.article.maximumQuantity &&
                this.quantity >= article.article.maximumQuantity
              }
            />
          </StyledAmountGroup>
          <StyledPriceCol>
            {!productsStore.hidePricesAndPoints &&
            position.pricePerItem !== null ? (
              <>
                <MediaQuery maxWidth={991}>{sumShortPrice}</MediaQuery>
                <MediaQuery minWidth={992}>{sumPrice}</MediaQuery>
              </>
            ) : (
              ''
            )}
          </StyledPriceCol>
          <StyledOptionsCol>
            {deletable ? (
              <>
                {isRemoving ? (
                  <span
                    className='d-flex justify-content-center'
                    style={{ width: '72px' }}
                  >
                    <Spinner animation='border' variant='primary' />
                  </span>
                ) : (
                  <StyledRemoveLink to={'#'} onClick={this.onClickRemove}>
                    {t('deleteButton')}
                  </StyledRemoveLink>
                )}
              </>
            ) : null}
          </StyledOptionsCol>
          <OverlayLoadingLayer isLoading={this.isLoading} />
        </StyledProductItemWrapper>
        {this.changeQuantityError ? (
          <Alert variant='danger' className='mb-3'>
            {this.changeQuantityError}
          </Alert>
        ) : (
          ''
        )}
      </React.Fragment>
    )
  }
}

export default withTheme(
  withTranslation()(
    inject('productsStore', 'productDetailsStore')(observer(ProductItem))
  )
)
